// extracted by mini-css-extract-plugin
export default {"navButton":"SwiperButton_navButton__QRwhV","navButtonHidden":"SwiperButton_navButtonHidden__DG3WQ"};